import { createAction } from "@reduxjs/toolkit";

export const trackHubSpotEvent = createAction<unknown>("HUBSPOT/TRACK_EVENT");
